<div class="flex h-full flex-col bg-card">
  <!-- Header -->
  <div class="flex items-center gap-3 border-b p-4">
    <div class="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-50 text-primary">
      <mat-icon svgIcon="heroicons_outline:map"></mat-icon>
    </div>
    <div class="min-w-0 flex-1">
      <div class="text-lg font-semibold leading-6 tracking-tight">Optimización de ruta</div>
      <div class="truncate text-sm font-medium text-primary">{{ subRouteName }}</div>
    </div>
    <button mat-icon-button (click)="close()" matTooltip="Cerrar">
      <mat-icon svgIcon="heroicons_outline:x-mark"></mat-icon>
    </button>
  </div>

  <!-- Body -->
  <div class="flex flex-auto flex-col overflow-y-auto p-4">
    <!-- Cargando datos -->
    <div *ngIf="state === 'loading'" class="flex flex-auto flex-col items-center justify-center gap-3 py-10">
      <mat-progress-spinner mode="indeterminate" diameter="40" color="primary"></mat-progress-spinner>
      <div class="text-secondary text-sm">Cargando clientes de la ruta…</div>
    </div>

    <!-- Optimizando -->
    <div *ngIf="state === 'optimizing'" class="flex flex-auto flex-col items-center justify-center gap-2 py-8">
      <app-route-loading-animation class="block h-44 w-56"></app-route-loading-animation>
      <div class="text-base font-semibold">
        {{ isMultiday ? 'Planificando la semana…' : 'Optimizando ruta…' }}
      </div>
      <div class="text-secondary max-w-xs text-center text-sm">
        Calculando con el motor de ruteo. Esto puede tardar unos segundos.
      </div>
    </div>

    <!-- Error -->
    <div *ngIf="state === 'error'" class="flex flex-auto flex-col items-center justify-center gap-3 py-10">
      <mat-icon class="text-warn icon-size-10" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
      <div class="text-base font-semibold">No se pudo optimizar</div>
      <!-- El detalle que devuelve la API: sin esto solo se veía un genérico. -->
      <div *ngIf="errorDetail"
        class="max-w-sm rounded-lg border border-rose-200 bg-rose-50 px-3 py-2 text-center text-xs text-rose-800">
        {{ errorDetail }}
      </div>
      <button mat-stroked-button color="primary" (click)="retry()">Reintentar</button>
    </div>

    <!-- Listo / Resultado -->
    <ng-container *ngIf="state === 'ready' || state === 'result'">
      <!-- Fuente de clientes -->
      <div class="mb-3 inline-flex rounded-lg bg-gray-100 p-1">
        <button type="button"
          class="rounded-md px-4 py-1.5 text-sm font-medium transition-colors"
          [class.bg-card]="clientSource === 'assigned'" [class.shadow]="clientSource === 'assigned'"
          [class.text-primary]="clientSource === 'assigned'" [class.text-secondary]="clientSource !== 'assigned'"
          (click)="onSourceChange('assigned')">Asignados</button>
        <button type="button"
          class="rounded-md px-4 py-1.5 text-sm font-medium transition-colors"
          [class.bg-card]="clientSource === 'unassigned'" [class.shadow]="clientSource === 'unassigned'"
          [class.text-primary]="clientSource === 'unassigned'" [class.text-secondary]="clientSource !== 'unassigned'"
          (click)="onSourceChange('unassigned')">Sin asignar</button>
        <button type="button"
          class="rounded-md px-4 py-1.5 text-sm font-medium transition-colors"
          [class.bg-card]="clientSource === 'all'" [class.shadow]="clientSource === 'all'"
          [class.text-primary]="clientSource === 'all'" [class.text-secondary]="clientSource !== 'all'"
          (click)="onSourceChange('all')">Todos</button>
      </div>

      <!-- Selector de alcance (solo Asignados: son los que tienen días de visita) -->
      <div *ngIf="supportsScope" class="mb-4 flex flex-col gap-3 rounded-lg border p-3">
        <mat-form-field appearance="fill" class="w-full" subscriptSizing="dynamic">
          <mat-label>Día</mat-label>
          <mat-select [(ngModel)]="selectedDay" (ngModelChange)="onScopeChange()">
            <mat-option [value]="0">Todos</mat-option>
            <mat-option *ngFor="let d of dayOptions" [value]="d.code">{{ d.label }}</mat-option>
          </mat-select>
        </mat-form-field>
        <!-- Fecha de inicio (solo multi-día) -->
        <div *ngIf="isMultiday" class="flex items-center gap-2">
          <label class="text-secondary text-xs font-medium">Semana desde</label>
          <input type="date" [(ngModel)]="startDate" (ngModelChange)="onScopeChange()"
            class="rounded-md border px-2 py-1 text-sm" />
        </div>
        <div class="text-secondary text-xs">
          <mat-icon class="icon-size-4 align-middle"
            [svgIcon]="isMultiday ? 'heroicons_outline:calendar-days' : 'heroicons_outline:map'"></mat-icon>
          {{ isMultiday
            ? 'Planeará la semana (el sistema elige el día de cada cliente).'
            : 'Optimizará el orden de un recorrido.' }}
        </div>
      </div>

      <!-- Sin asignar / Todos: propuesta de día sobre los días de la sub-ruta -->
      <div *ngIf="!supportsScope" class="mb-4 flex flex-col gap-2 rounded-lg border p-3">
        <div class="text-secondary text-xs">
          <mat-icon class="icon-size-4 align-middle"
            [svgIcon]="isMultiday ? 'heroicons_outline:calendar-days' : 'heroicons_outline:map'"></mat-icon>
          {{ isMultiday
            ? 'Propondrá un día a cada cliente sobre los días de la sub-ruta: ' + (workingDaysLabel || '—')
            : 'Optimizará el orden de un recorrido.' }}
        </div>
        <div *ngIf="isMultiday" class="flex items-center gap-2">
          <label class="text-secondary text-xs font-medium">Semana desde</label>
          <input type="date" [(ngModel)]="startDate" (ngModelChange)="onScopeChange()"
            class="rounded-md border px-2 py-1 text-sm" />
        </div>
      </div>

      <!-- Dashboard de KPIs (resultado multi-día) -->
      <div *ngIf="state === 'result' && resultMode === 'multiday' && dash"
        class="mb-4 grid grid-cols-2 gap-2 sm:grid-cols-4">
        <div class="rounded-lg border p-3">
          <div class="flex items-center gap-2 text-secondary text-xs font-medium">
            <mat-icon class="icon-size-4 text-primary" svgIcon="heroicons_outline:user-group"></mat-icon>
            VISITAS / DÍA
          </div>
          <div class="mt-1 text-2xl font-bold">{{ dash.visitsPerDay }}</div>
        </div>
        <div class="rounded-lg border p-3">
          <div class="flex items-center gap-2 text-secondary text-xs font-medium">
            <mat-icon class="icon-size-4 text-primary" svgIcon="heroicons_outline:map"></mat-icon>
            DISTANCIA TOTAL
          </div>
          <div class="mt-1 text-2xl font-bold">{{ dash.distanceKm | number: '1.0-1' }} km</div>
        </div>
        <div class="rounded-lg border p-3">
          <div class="flex items-center gap-2 text-secondary text-xs font-medium">
            <mat-icon class="icon-size-4 text-amber-600" svgIcon="heroicons_outline:clock"></mat-icon>
            DURACIÓN TOTAL
          </div>
          <div class="mt-1 text-2xl font-bold">{{ formatDuration(dash.durationMin) }}</div>
        </div>
        <div class="rounded-lg border p-3">
          <div class="flex items-center gap-2 text-secondary text-xs font-medium">
            <mat-icon class="icon-size-4 text-green-600" svgIcon="heroicons_outline:check-circle"></mat-icon>
            PARADAS
          </div>
          <div class="mt-1 text-2xl font-bold">
            {{ dash.planned }}<span *ngIf="dash.unplanned" class="text-base font-medium text-rose-600"> / {{ dash.unplanned }} sin</span>
          </div>
        </div>
      </div>

      <!-- Resumen resultado /sort -->
      <div *ngIf="state === 'result' && resultMode === 'sort' && result"
        class="mb-4 flex items-center gap-2 rounded-lg bg-green-50 p-3">
        <mat-icon class="text-green-600" svgIcon="heroicons_outline:check-circle"></mat-icon>
        <span class="text-sm font-medium text-green-800">
          Ruta optimizada · {{ result.total_distance_km | number: '1.0-1' }} km ·
          {{ result.total_duration_min }} min
        </span>
      </div>

      <!-- Paradas que el SERVICIO apartó por su coordenada.
           Van pegadas al aviso de GPS inválido de abajo porque para el usuario es
           la misma pregunta: "¿por qué falta este cliente?". Sin este bloque la
           parada desaparecía del recorrido sin dejar rastro. -->
      <div *ngIf="serviceExcluded.length > 0"
        class="mb-4 overflow-hidden rounded-lg border border-amber-200 bg-amber-50 p-3">
        <div class="flex items-center gap-2">
          <mat-icon class="text-amber-600" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
          <span class="text-sm font-medium text-amber-800">
            {{ serviceExcluded.length }} cliente(s) quedaron fuera del recorrido por su ubicación.
          </span>
        </div>
        <ul class="mt-2 space-y-1.5">
          <li *ngFor="let e of serviceExcluded" class="text-xs text-amber-900">
            <span class="font-medium">{{ e.name }}</span>
            <span class="text-amber-700"> — {{ e.reason }}</span>
            <div [hidden]="!e.help" class="text-amber-700/80">{{ e.help }}</div>
          </li>
        </ul>
      </div>

      <!-- Tabla colapsable de clientes con GPS inválido (sin coords / lat o lon en 0 / fuera de rango) -->
      <div *ngIf="excludedCount > 0" class="mb-4 overflow-hidden rounded-lg border border-amber-200 bg-amber-50">
        <button type="button" class="flex w-full items-center gap-2 p-3 text-left"
          (click)="showExcluded = !showExcluded">
          <mat-icon class="text-amber-600" svgIcon="heroicons_outline:exclamation-triangle"></mat-icon>
          <span class="flex-1 text-sm font-medium text-amber-800">
            {{ excludedCount }} cliente(s) con coordenadas inválidas quedaron fuera (revisar GPS).
          </span>
          <mat-icon class="text-amber-600 icon-size-5"
            [svgIcon]="showExcluded ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"></mat-icon>
        </button>
        <div *ngIf="showExcluded" class="max-h-60 overflow-y-auto px-3 pb-3">
          <table class="w-full text-xs">
            <thead class="sticky top-0 bg-amber-50 text-left text-amber-800">
              <tr>
                <th class="py-1 pr-2 font-semibold">Cliente</th>
                <th class="py-1 px-2 font-semibold">Lat</th>
                <th class="py-1 pl-2 font-semibold">Lon</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let r of excludedRows" class="border-t border-amber-200/60">
                <td class="truncate py-1.5 pr-2 text-amber-900" [title]="r.name">{{ r.name }}</td>
                <td class="py-1.5 px-2 font-mono"
                  [class.text-rose-600]="r.latBad" [class.font-bold]="r.latBad" [class.text-amber-700]="!r.latBad">
                  {{ r.lat }}
                </td>
                <td class="py-1.5 pl-2 font-mono"
                  [class.text-rose-600]="r.lonBad" [class.font-bold]="r.lonBad" [class.text-amber-700]="!r.lonBad">
                  {{ r.lon }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Contador -->
      <div class="mb-2 flex items-center justify-between">
        <span class="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-700">
          {{ scopedClients.length }} paradas en el alcance
        </span>
      </div>

      <!-- Lista del alcance (estado listo) -->
      <ng-container *ngIf="state === 'ready'">
        <!-- Con un día concreto: lista plana. -->
        <div *ngIf="selectedDay" class="flex flex-col gap-2">
          <div *ngFor="let c of scopedClients; let i = index" class="flex items-center gap-3 rounded-lg border p-3">
            <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-50 text-xs font-semibold text-primary">
              {{ i + 1 }}
            </div>
            <div class="min-w-0 flex-1">
              <div class="truncate text-sm font-medium">{{ c.commercialName || c.name }}</div>
              <div class="text-secondary truncate text-xs">{{ c.principalAddress?.address }}</div>
            </div>
            <mat-icon class="text-green-500 icon-size-5" svgIcon="heroicons_outline:map-pin"></mat-icon>
          </div>
        </div>

        <!-- Con el día en "Todos": una sección por día, para revisar la carga
             de cada jornada antes de planear. Un cliente de varios días aparece
             en cada uno (se lo visita en todos). -->
        <div *ngIf="!selectedDay" class="flex flex-col gap-4">
          <div *ngFor="let g of scopeGroups" class="overflow-hidden rounded-lg border">
            <div class="flex items-center justify-between border-b bg-gray-50 px-3 py-2">
              <span class="text-sm font-semibold" [class.text-amber-700]="g.code === null">{{ g.label }}</span>
              <span class="text-secondary text-xs">{{ g.clients.length }} cliente(s)</span>
            </div>
            <div class="flex flex-col gap-2 p-2">
              <div *ngFor="let c of g.clients; let i = index" class="flex items-center gap-3 rounded-md px-2 py-1.5">
                <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-primary-50 text-[11px] font-semibold text-primary">
                  {{ i + 1 }}
                </div>
                <div class="min-w-0 flex-1">
                  <div class="truncate text-sm font-medium">{{ c.commercialName || c.name }}</div>
                  <div class="text-secondary truncate text-xs">{{ c.principalAddress?.address }}</div>
                </div>
                <mat-icon class="text-green-500 icon-size-5" svgIcon="heroicons_outline:map-pin"></mat-icon>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Tabs Lista / Mapa (solo en resultado) -->
      <div *ngIf="state === 'result'" class="mb-3 inline-flex rounded-lg bg-gray-100 p-1">
        <button type="button"
          class="flex items-center gap-1.5 rounded-md px-4 py-1.5 text-sm font-medium transition-colors"
          [class.bg-card]="activeTab === 'list'"
          [class.shadow]="activeTab === 'list'"
          [class.text-primary]="activeTab === 'list'"
          [class.text-secondary]="activeTab !== 'list'"
          (click)="activeTab = 'list'">
          <mat-icon class="icon-size-4" svgIcon="heroicons_outline:list-bullet"></mat-icon>
          Lista
        </button>
        <button type="button"
          class="flex items-center gap-1.5 rounded-md px-4 py-1.5 text-sm font-medium transition-colors"
          [class.bg-card]="activeTab === 'map'"
          [class.shadow]="activeTab === 'map'"
          [class.text-primary]="activeTab === 'map'"
          [class.text-secondary]="activeTab !== 'map'"
          (click)="activeTab = 'map'">
          <mat-icon class="icon-size-4" svgIcon="heroicons_outline:map"></mat-icon>
          Mapa
        </button>
      </div>

      <!-- Mapa (montado solo al abrir la pestaña → Leaflet se dimensiona bien) -->
      <div *ngIf="state === 'result' && activeTab === 'map'" class="flex flex-col gap-2">
        <!-- Selector de día a renderizar (multi-día) + oficina de salida -->
        <div class="flex flex-col gap-2">
          <div *ngIf="resultMode === 'multiday' && multidayDays.length" class="flex flex-col gap-2">
            <span class="text-secondary text-xs font-medium">Día a mostrar en el mapa:</span>
            <div class="flex flex-wrap gap-2">
              <button *ngFor="let d of multidayDays" type="button"
                class="rounded-full border px-3 py-1 text-xs font-medium transition-all"
                [class.border-primary]="selectedMapDate === d.date"
                [class.bg-primary-50]="selectedMapDate === d.date"
                [class.text-primary]="selectedMapDate === d.date"
                [class.opacity-60]="selectedMapDate !== d.date"
                (click)="selectMapDate(d.date)">
                {{ d.dayLabel }} · {{ d.date }} ({{ dayStopCount(d) }})
              </button>
            </div>
            <!-- Leyenda de recorridos del día seleccionado (solo si hay más de uno) -->
            <div *ngIf="selectedDayTrucks.length > 1" class="flex flex-wrap gap-3">
              <span *ngFor="let t of selectedDayTrucks" class="flex items-center gap-1.5 text-xs font-medium">
                <span class="h-3 w-3 rounded-full" [style.background-color]="t.color"></span>
                {{ t.label }} ({{ t.stops.length }})
              </span>
            </div>
          </div>
          <div *ngIf="originGroup" class="flex items-center gap-1.5 text-xs text-secondary">
            <mat-icon class="icon-size-4 text-gray-800" svgIcon="heroicons_outline:building-storefront"></mat-icon>
            Origen del recorrido: {{ originGroup.markers[0].title }} (salida y regreso)
          </div>
        </div>
        <div class="h-[58vh] overflow-hidden rounded-lg border">
          <ng-container *ngIf="visibleMarkerGroups.length; else noMap">
            <!-- Recreado por día (containerId único) → mapa limpio sin marcadores apilados -->
            <app-geo-manager *ngFor="let key of [mapRenderKey]; trackBy: trackByKey"
              [containerId]="'route-opt-map-' + key"
              [markerGroups]="visibleMarkerGroups"
              [zoom]="12"
              displayMode="tooltip"
              [captions]="{ title: 'Mapa de la ruta' }"
              class="block h-full w-full"></app-geo-manager>
          </ng-container>
          <ng-template #noMap>
            <div class="flex h-full items-center justify-center text-secondary text-sm">
              Sin paradas para mostrar.
            </div>
          </ng-template>
        </div>
      </div>

      <!-- Resultado /sort -->
      <div *ngIf="state === 'result' && activeTab === 'list' && resultMode === 'sort'" class="flex flex-col gap-2">
        <div *ngFor="let row of resultRows" class="flex items-center gap-3 rounded-lg border p-3">
          <div class="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary text-xs font-semibold text-white">
            {{ row.sequence }}
          </div>
          <div class="min-w-0 flex-1">
            <div class="truncate text-sm font-medium">{{ row.name }}</div>
            <div class="text-secondary truncate text-xs">{{ row.address }}</div>
          </div>
          <div class="flex flex-col items-end gap-0.5">
            <span class="text-xs font-medium">{{ row.etaMin }} min</span>
            <span *ngIf="row.delta !== 0" class="text-xs font-semibold"
              [class.text-green-600]="row.delta > 0" [class.text-rose-600]="row.delta < 0">
              {{ row.delta > 0 ? '↑' : '↓' }}{{ row.delta > 0 ? row.delta : -row.delta }}
            </span>
          </div>
        </div>
      </div>

      <!-- Resultado /plan-multiday (por día) -->
      <div *ngIf="state === 'result' && activeTab === 'list' && resultMode === 'multiday'"
        cdkDropListGroup class="flex flex-col gap-4">

        <!-- Cambios sin aplicar: el plan de abajo todavía no los contempla, y
             hay que decir qué días se recalculan para que nadie lea los otros
             como más frescos de lo que son. -->
        <div *ngIf="hasPendingChanges"
          class="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-200 bg-amber-50 p-3">
          <div class="min-w-0">
            <div class="text-sm font-medium text-amber-800">
              {{ pendingChanges }} cambio(s) sin aplicar — el plan que ves es el de la corrida anterior.
            </div>
            <div class="mt-0.5 text-xs text-amber-700">
              Se recalcula: <span class="font-semibold">{{ affectedDaysLabel || '—' }}</span>
              <ng-container *ngIf="untouchedDaysLabel">
                · queda como está: {{ untouchedDaysLabel }}
              </ng-container>
            </div>
          </div>
          <div class="flex items-center gap-2">
            <button mat-stroked-button (click)="clearSubstitutions()">Descartar</button>
            <button mat-stroked-button (click)="replanAll()"
              title="Recalcula el horizonte completo, sin conservar ningún día">
              Replanificar todo
            </button>
            <button mat-flat-button color="primary" (click)="replanPending()">
              <mat-icon svgIcon="heroicons_outline:arrow-path"></mat-icon>
              Replanificar
            </button>
          </div>
        </div>
        <!-- Reprogramadas a un día posterior — colapsable, agrupadas por día destino.
             El conteo cuenta CLIENTES, no eventos del planificador: una orden que
             rueda varios días ocupa una sola entrada. Las que terminaron sin ningún
             día NO están acá; salen abajo, en el bloque rojo, con su motivo final. -->
        <div *ngIf="rolloverCount" class="overflow-hidden rounded-lg border border-blue-200 bg-blue-50">
          <button type="button" class="flex w-full items-center gap-2 p-3 text-left"
            (click)="showRollovers = !showRollovers">
            <mat-icon class="icon-size-4 text-blue-600" svgIcon="heroicons_outline:arrow-path"></mat-icon>
            <span class="flex-1 text-sm font-medium text-blue-800">
              {{ rolloverCount }} cliente(s) reprogramados a un día posterior
              <span class="font-normal text-blue-600">
                · {{ rolloverGroups.length }} día(s) destino
              </span>
            </span>
            <mat-icon class="icon-size-5 text-blue-600"
              [svgIcon]="showRollovers ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"></mat-icon>
          </button>
          <div *ngIf="showRollovers" class="max-h-72 overflow-y-auto px-3 pb-3">
            <div *ngFor="let g of rolloverGroups" class="mb-3 last:mb-0">
              <div class="mb-1 flex items-center gap-2 text-xs font-semibold text-blue-700">
                <span class="rounded-full bg-blue-200 px-2 py-0.5">{{ g.items.length }}</span>
                {{ rolloverDayLabel(g.date) }} {{ g.date }}
              </div>
              <div class="flex flex-col gap-1">
                <div *ngFor="let it of g.items"
                  class="rounded-md bg-white px-2 py-1.5 ring-1 ring-blue-100">
                  <div class="flex items-center gap-1.5">
                    <span class="truncate text-sm font-medium text-slate-800">{{ it.name }}</span>
                    <!-- Lo único que se pierde al colapsar la cadena, y lo único de
                         ella que importa: un cliente que rueda varios días está
                         sistemáticamente al final de la cola. -->
                    <span *ngIf="it.rolledDays > 1"
                      class="shrink-0 rounded-full bg-blue-100 px-1.5 text-[10px] font-bold text-blue-700"
                      [title]="'No entró en ' + it.rolledDays + ' días seguidos'">
                      rodó {{ it.rolledDays }} días
                    </span>
                  </div>
                  <div class="text-xs text-blue-700">{{ it.reason }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- No planificadas (sin día asignado), categorizadas por motivo — arriba -->
        <div *ngIf="unplannedCount" class="overflow-hidden rounded-lg border border-rose-200 bg-rose-50">
          <!-- El encabezado lleva el reparto por motivo porque este bloque es
               ACCIONABLE: adentro vive el origen del arrastre. Colapsarlo sin decir
               qué hay adentro escondería trabajo pendiente. -->
          <button type="button" class="flex w-full items-center gap-2 p-3 text-left"
            (click)="showUnplanned = !showUnplanned">
            <mat-icon class="icon-size-4 text-rose-600" svgIcon="heroicons_outline:x-circle"></mat-icon>
            <span class="flex min-w-0 flex-1 flex-col gap-0.5">
              <span class="text-sm font-medium text-rose-800">
                {{ unplannedCount }} cliente(s) sin día asignado (no se pudieron planificar)
              </span>
              <span class="truncate text-xs font-medium text-rose-600">{{ unplannedSummaryLine }}</span>
            </span>
            <mat-icon class="icon-size-5 shrink-0 text-rose-600"
              [svgIcon]="showUnplanned ? 'heroicons_outline:chevron-up' : 'heroicons_outline:chevron-down'"></mat-icon>
          </button>
          <!-- Acotado en alto además del colapso: desplegado, en corrida real son
               decenas y empujaban el resto del plan fuera de la vista. -->
          <!-- Una tarjeta por cliente, agrupadas por motivo. En corrida real son
               decenas: el texto corrido separado por puntos era ilegible, y una
               tarjeta es además lo que se arrastra a un día. -->
          <div *ngIf="showUnplanned" class="max-h-72 overflow-y-auto px-3 pb-3 pr-1">
          <div *ngFor="let g of unplannedGroups" class="mb-3 last:mb-0">
            <div class="mb-1 flex items-center gap-2 text-xs font-semibold text-rose-700">
              <span class="rounded-full bg-rose-200 px-2 py-0.5">{{ g.items.length }}</span>
              {{ g.label }}
            </div>
            <!-- ESTA lista es el ORIGEN del arrastre. Sin `cdkDropList` acá el CDK
                 no puede transferir el ítem a otra lista: la tarjeta se arrastra
                 y vuelve sola. `enterPredicate` en false la hace de una sola vía
                 (nada regresa desde un día). -->
            <div class="flex flex-col gap-1"
              cdkDropList [cdkDropListData]="'unplanned'" [cdkDropListEnterPredicate]="rejectDrop"
              [cdkDropListSortingDisabled]="true">
              <div *ngFor="let it of g.items"
                cdkDrag [cdkDragData]="it" [cdkDragDisabled]="!canPin(it) || state === 'optimizing'"
                class="flex items-start gap-2 rounded-md bg-white px-2 py-1.5 ring-1 ring-rose-100"
                [class.cursor-move]="canPin(it)"
                [title]="canPin(it) ? 'Arrastrá a un día para asignarlo' : 'Cambiar de día no resolvería este caso'">
                <mat-icon class="icon-size-4 mt-0.5 shrink-0"
                  [class.text-rose-400]="!canPin(it)" [class.text-slate-400]="canPin(it)"
                  [svgIcon]="canPin(it) ? 'heroicons_outline:bars-3' : 'heroicons_outline:no-symbol'"></mat-icon>
                <div class="min-w-0 flex-1">
                  <div class="flex items-center gap-1.5">
                    <span class="truncate text-sm font-medium text-slate-800">{{ it.name }}</span>
                    <!-- Salió por decisión del usuario, no porque el motor fallara. -->
                    <span *ngIf="isDisplaced(it.id)"
                      class="shrink-0 rounded-full bg-slate-200 px-1.5 text-[10px] font-bold text-slate-700"
                      title="Lo desplazaste vos al sustituirlo">desplazado</span>
                  </div>
                  <div class="text-secondary truncate text-xs">{{ it.address }}</div>
                  <!-- El porqué, en la propia tarjeta: con decenas agrupadas, el
                       encabezado del motivo se pierde al hacer scroll. El botón
                       despliega qué significa y qué se puede hacer. -->
                  <button type="button"
                    class="mt-1 inline-flex max-w-full items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-medium transition-colors"
                    [class.bg-rose-100]="!canPin(it)" [class.text-rose-700]="!canPin(it)"
                    [class.hover:bg-rose-200]="!canPin(it)"
                    [class.bg-amber-100]="canPin(it)" [class.text-amber-800]="canPin(it)"
                    [class.hover:bg-amber-200]="canPin(it)"
                    (click)="toggleReason(it.id)"
                    [attr.aria-expanded]="expandedReasonId === it.id">
                    <mat-icon class="icon-size-3.5 shrink-0" svgIcon="heroicons_outline:information-circle"></mat-icon>
                    <span class="truncate">{{ g.label }}</span>
                    <mat-icon class="icon-size-3.5 shrink-0 transition-transform"
                      [class.rotate-180]="expandedReasonId === it.id"
                      svgIcon="heroicons_outline:chevron-down"></mat-icon>
                  </button>
                  <div *ngIf="expandedReasonId === it.id"
                    class="mt-1 rounded-md bg-slate-50 p-2 text-[11px] leading-relaxed text-slate-700 ring-1 ring-slate-200">
                    {{ reasonHelp(it.reason) }}
                  </div>
                </div>
                <!-- Vista previa mientras se arrastra. -->
                <div *cdkDragPreview class="rounded-md bg-white px-3 py-2 text-sm font-medium shadow-lg ring-1 ring-primary">
                  {{ it.name }}
                </div>
              </div>
            </div>
          </div>
          </div>
        </div>

        <!-- El día NO es zona de destino: el planificador ya lo llenó hasta donde
             entra, así que soltar "en el día" haría que el motor elija en silencio
             a quién saca. El destino es siempre una fila. -->
        <div *ngFor="let day of multidayDays" class="overflow-hidden rounded-lg border">
          <div class="flex items-center justify-between border-b bg-gray-50 px-3 py-2">
            <span class="text-sm font-semibold">{{ day.dayLabel }} · {{ day.date }}</span>
            <span class="text-secondary text-xs">
              {{ dayStopCount(day) }} visitas
              <ng-container *ngIf="dayLastArrival(day)">· última {{ dayLastArrival(day) }}</ng-container>
            </span>
          </div>

          <!-- Un día sin visitas necesita una fila de destino: son justo los que
               el planificador deja vacíos, o sea el caso central del reequilibrio. -->
          <div *ngIf="!dayStopCount(day)" class="p-2">
            <div class="rounded-md border border-dashed border-slate-300 px-3 py-4 text-center text-xs text-slate-500"
              cdkDropList [cdkDropListData]="day.date"
              [cdkDropListSortingDisabled]="true"
              (cdkDropListDropped)="onDropOnEmptyDay($event, day)">
              Sin visitas — soltá acá un cliente para asignarlo a este día
            </div>
          </div>

          <!-- Una sección por recorrido (oculta cuando hay uno solo) -->
          <div *ngFor="let truck of day.trucks" class="border-b border-l-4 last:border-b-0"
            [style.border-left-color]="truck.color">
            <!-- Con un solo recorrido por día (el caso de preventa) la banda no
                 aporta nada: las paradas cuelgan directamente del día. -->
            <div *ngIf="day.trucks.length > 1" class="flex items-center gap-2 bg-gray-50/60 px-3 py-1.5">
              <span class="h-3 w-3 rounded-full" [style.background-color]="truck.color"></span>
              <span class="text-xs font-semibold">{{ truck.label }}</span>
              <span class="text-secondary text-xs">· {{ truck.stops.length }} visitas</span>
            </div>
            <div class="flex flex-col gap-1 p-2">
              <!-- Cada parada es el destino: soltar acá la sustituye. -->
              <div *ngFor="let s of truck.stops"
                class="flex items-center gap-3 rounded-md px-2 py-1.5 transition-colors"
                cdkDropList [cdkDropListData]="s.id"
                [cdkDropListSortingDisabled]="true"
                (cdkDropListDropped)="onDropOnStop($event, day, s)"
                [title]="'Soltá un cliente acá para reemplazar a ' + s.name">
                <div class="flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[11px] font-semibold text-white"
                  [style.background-color]="truck.color">
                  {{ s.sequence }}
                </div>
                <div class="min-w-0 flex-1">
                  <div class="flex items-center gap-1.5">
                    <span class="truncate text-sm font-medium">{{ s.name }}</span>
                    <!-- Se distingue lo que puso el usuario de lo que decidió el motor. -->
                    <span *ngIf="isManual(s.id)"
                      class="shrink-0 rounded-full bg-indigo-50 px-1.5 text-[10px] font-bold text-indigo-600"
                      title="Asignado manualmente">manual</span>
                  </div>
                  <div class="text-secondary truncate text-xs">{{ s.address }}</div>
                </div>
                <button *ngIf="isManual(s.id)" type="button" class="shrink-0 text-secondary hover:text-rose-600"
                  title="Deshacer la sustitución" (click)="removeSubstitution(s.id)">
                  <mat-icon class="icon-size-4" svgIcon="heroicons_outline:x-mark"></mat-icon>
                </button>
                <span class="text-xs font-medium">{{ s.arrivalTime }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>

  <!-- Footer -->
  <div class="flex flex-col gap-2 border-t p-4">
    <button mat-flat-button color="primary" class="w-full" *ngIf="state !== 'result'"
      [disabled]="!canOptimize || state === 'optimizing'" (click)="optimize()">
      <mat-icon svgIcon="heroicons_outline:sparkles"></mat-icon>
      {{ state === 'optimizing'
        ? (isMultiday ? 'Planificando…' : 'Optimizando…')
        : (isMultiday ? 'Planear' : 'Optimizar ruta') }}
    </button>
    <button mat-stroked-button color="primary" class="w-full" *ngIf="state === 'result'" (click)="retry()">
      Volver a optimizar
    </button>
  </div>
</div>
